import React from "react";
import TextInput from "./element/TextInput";
import DeleteButton from "./element/DeleteButton";

function FormReference({
  itemId,
  reference,
  referenceId,
  updateData,
  removeData,
}) {
  function handleChange(e) {
    updateData({
      category: "reference",
      mainId: referenceId,
      subId: itemId,
      property: e.target.name,
      newValue: e.target.value,
    });
  }
  function handleDelete() {
    removeData({
      category: "itemReference",
      mainId: referenceId,
      subId: itemId,
    });
  }
  return (
    <>
      <div className="flex mb-2 gap-4">
        {" "}
        <div>
          <TextInput
            labelText="Name:"
            inputName="name"
            inputOnChange={handleChange}
            inputValue={reference.name}
          />
          <TextInput
            labelText="Job Title:"
            inputName="jobTitle"
            inputOnChange={handleChange}
            inputValue={reference.jobTitle}
          />
          <TextInput
            labelText="Company:"
            inputName="companyName"
            inputOnChange={handleChange}
            inputValue={reference.companyName}
          />
          <TextInput
            labelText="Phone:"
            inputName="phone"
            inputOnChange={handleChange}
            inputValue={reference.phone}
          />
          <TextInput
            labelText="Email:"
            inputName="email"
            inputOnChange={handleChange}
            inputValue={reference.email}
          />
        </div>
        <div className="mt-0.5">
          {" "}
          <DeleteButton handleDelete={handleDelete} />
        </div>{" "}
      </div>
    </>
  );
}

export default FormReference;
